import { CiAdvancedMultipleChoice } from '../../../../../ui/icons-custom/IconsCustom.tsx';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { ItemRangeRule } from '../../../../rules/repository/item-range/ItemRange.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { OptionsTranslationSchema } from '../../translations/OptionsTranslationSchema.ts';
import { AdvancedSelectWidgetPreview } from '../advanced-select-common/AdvancedSelectWidgetPreview.tsx';
import { AdvancedMultiSelectWidgetComponent } from './AdvancedMultiSelectWidgetComponent.tsx';
import {
  AdvancedMultiSelectWidgetConfigComponent,
  AdvancedMultiSelectWidgetConfigSchema,
} from './AdvancedMultiSelectWidgetConfigComponent.tsx';
import { createAdvancedMultiSelectFormSchema } from './createAdvancedMultiSelectFormSchema.ts';
import {
  getAdvancedMultiSelectWidgetOptionsReferences,
  getAdvancedMultiSelectWidgetReference,
} from './getAdvancedMultiSelectWidgetReference.ts';
import { hydrateAdvancedMultiSelectWidget } from './hydrateAdvancedMultiSelectWidget.ts';
import { type IAdvancedMultiSelectWidget } from './IAdvancedMultiSelectWidget.ts';

/**
 * Tipo del widget di selezione multipla avanzata.
 */
export const AdvancedMultiSelectWidgetType: IWidgetType<IAdvancedMultiSelectWidget> =
  {
    type: WidgetType.AdvancedMultiSelect,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Input,
    name: 'Campo scelta multipla avanzata',
    icon: <CiAdvancedMultipleChoice />,
    hasValue: true,
    getReference: getAdvancedMultiSelectWidgetReference,
    getSiblingReferences: getAdvancedMultiSelectWidgetOptionsReferences,
    hydrate: hydrateAdvancedMultiSelectWidget,
    formComponent: AdvancedMultiSelectWidgetComponent,
    createFormSchema: createAdvancedMultiSelectFormSchema,
    previewComponent: AdvancedSelectWidgetPreview,
    configValidator: AdvancedMultiSelectWidgetConfigSchema,
    configComponent: AdvancedMultiSelectWidgetConfigComponent,
    translationSchema: tran.widget({
      ...InputCommonTranslationSchema.objectShape,
      options: OptionsTranslationSchema,
      buttonText: tran.string(),
    }),
    rules: [RequiredRule, ItemRangeRule, CustomWarningsRule],
  };
